import { useSuspenseQuery } from '@tanstack/react-query';

import {
  getArticleValidationOptions,
  useValidateArticle,
} from '@/module/Author/Article/Validation/model/ArticleValidationModel';

import { Id, useAppNotification } from '@feature/utils';
import { ValidationRequest, ValidationVariant } from '@feature/validation';
import { ValidationAction } from '@feature/validation/ValidationAction';

interface ValidationActionProps {
  articleId: Id;
  variant?: ValidationVariant;
}

export function ArticleValidationAction({ articleId, variant }: ValidationActionProps) {
  const { data } = useSuspenseQuery(getArticleValidationOptions(articleId));
  const notification = useAppNotification();
  const { mutate, isPending } = useValidateArticle(articleId);

  const onSubmit = (request: ValidationRequest) => {
    mutate(request, {
      onSuccess: notification.success,
      onError: notification.error,
    });
  };

  return (
    <ValidationAction
      validation={data}
      isPending={isPending}
      onSubmit={onSubmit}
      variant={variant}
    />
  );
}
